import { render, staticRenderFns } from "./SFXEditInstance.vue?vue&type=template&id=581b7008&"
import script from "./SFXEditInstance.vue?vue&type=script&lang=js&"
export * from "./SFXEditInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports